module.exports = __webpack_public_path__ + "img/info-icon.003244d7.svg";